import { defineWidgetCore } from "../../widgetDefinition";
import type { LogoComponentSpec } from "../../Processing/types";
import { renderLogo } from "../../PDF/renderers/logoPdfRenderer";

export const logoCore = defineWidgetCore<LogoComponentSpec>({
  process(spec) {
    const s = spec;
    const teamName = s.display?.teamName ?? "Team";
    const initials =
      s.display?.initials ??
      teamName
        .split(/\s+/)
        .map((w) => w[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    return { type: "logo", spec: s, logo: { teamName, initials } };
  },
  pdf: {
    buildSnapshot({ processed, teamLogo }) {
      if (processed.type !== "logo") return null;
      return {
        type: "logo",
        teamName: processed.logo.teamName,
        initials: processed.logo.initials,
        logoUrl: teamLogo,
      };
    },
    render({ snapshot, rect, scale }) {
      if (snapshot.type !== "logo") return null;
      return renderLogo(snapshot, rect, scale);
    },
  },
});
